import React from "react";
import "../assets/css/main.css";
import heroImage from "../assets/img/hero.jpg";

function HeroComponent() {
  return (
    <section id="hero" class="hero section">
      <div class="hero-background">
        <img
          src={heroImage}
          alt=""
          data-aos="zoom-out"
          data-aos-duration="1000"
          class="aos-init aos-animate"
        />
        <div class="overlay"></div>
      </div>

      <div
        class="container aos-init aos-animate"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="hero-content">
              <span
                class="hero-badge aos-init aos-animate"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                Innovative Solutions
              </span>
              <h1
                data-aos="fade-right"
                data-aos-delay="400"
                class="aos-init aos-animate"
              >
                Transform Your <br /> Business with <br /> Modern Technology
              </h1>
              <p
                data-aos="fade-right"
                data-aos-delay="500"
                class="aos-init aos-animate"
              >
                Building Future-Ready Digital Solutions. We craft
                high-performance web, mobile, and cloud platforms that help
                businesses innovate, scale, and succeed in a fast-moving digital
                world.
              </p>
              <div
                class="hero-actions aos-init aos-animate"
                data-aos="fade-right"
                data-aos-delay="600"
              >
                <a href="#services" class="btn-primary">
                  Explore Services
                </a>
                <a
                  href="tel:+16176868789"
                  target="_blank"
                  class="btn-secondary glightbox"
                >
                  <i class="bi bi-telephone-forward-fill"></i>
                  <span>Get a Free Consultation</span>
                </a>
              </div>
              <div
                class="hero-stats aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="700"
              >
                <div class="stat-item">
                  <span class="stat-number">500+</span>
                  <span class="stat-label">Projects Completed</span>
                </div>
                <div class="stat-item">
                  <span class="stat-number">98%</span>
                  <span class="stat-label">Client Satisfaction</span>
                </div>
                <div class="stat-item">
                  <span class="stat-number">+45%</span>
                  <span class="stat-label">Web Traffic Growth</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div
              class="hero-visual aos-init aos-animate"
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <div class="row g-3">
                <div class="col-6">
                  <div
                    class="feature-card aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    <i class="bi bi-shield-check"></i>
                    <span>Secure &amp; Reliable</span>
                  </div>
                  <div
                    class="feature-card aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay="700"
                  >
                    <i class="bi bi-people"></i>
                    <span>Expert Team</span>
                  </div>
                </div>
                <div class="col-6">
                  <div
                    class="feature-card aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay="600"
                  >
                    <i class="bi bi-speedometer2"></i>
                    <span>Rapid Delivery</span>
                  </div>
                  <div
                    class="feature-card aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay="800"
                  >
                    <i class="bi bi-phone"></i>
                    <span>Mobile-First</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroComponent;
